import { Button, Icon } from "@legal-500/legal500-design-system";
import styles from "./QuestionLibrary.module.css";

// Default (source-language) description / hint input for a library question, plus a
// "Clear description" action that wipes both the default text and every per-language
// translation so the persisted payload becomes null. Kept in its own file to avoid
// further inflating the already-oversized modal (mirrors SubjectLabelField).
type DescriptionFieldProps = {
  value: string;
  onChange: (value: string) => void;
  /** Shown only when a description or its translations currently have content. */
  showClear: boolean;
  onClear: () => void;
};

function DescriptionField({ value, onChange, showClear, onClear }: DescriptionFieldProps) {
  return (
    <div className={styles.formFieldFull}>
      <div className={styles.translationHeader}>
        <label className={styles.fieldLabel}>Description</label>
        {showClear && (
          <Button
            variant="outlined"
            size="small"
            color="error"
            onClick={onClear}
            startIcon={<Icon icon="delete" size="small" />}
          >
            Clear description (with translations)
          </Button>
        )}
      </div>
      <textarea
        className={styles.textareaField}
        rows={2}
        value={value}
        onChange={event => onChange(event.target.value)}
        placeholder="Optional description for respondents"
      />
    </div>
  );
}

export { DescriptionField };
